import React, { Component } from "react";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import axios from "axios";
import { AutoComplete } from "primereact/autocomplete";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import "react-datepicker/dist/react-datepicker.css";
import * as appConst from "../../Common/constants";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";

export default class Return extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accounts: []
    };
  }

  componentDidMount() {
    this.LoadData();
  }

  LoadData() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/account/getCheques"
      )
      .then(response => {
        this.setState({ accounts: response.data });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Pending Cheque</h5>

        <div>
          <div className="ag-theme-blue" style={this.getHeight()}>
            <AgGridReact
              rowData={this.state.accounts}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                field="txndate"
                headerName="Txn Date"
                width={120}
                sortable
                resizable
                filter
                valueFormatter={this.dateFormatter}
              />
              <AgGridColumn
                field="chdate"
                headerName="Cheque Date"
                width={120}
                sortable
                resizable
                filter
                valueFormatter={this.dateFormatter}
              />
              <AgGridColumn
                field="chBank"
                headerName="Bank"
                width={200}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="chNo"
                headerName="Cheque No"
                width={100}
                sortable
                resizable
                filter
              />

              <AgGridColumn
                field="chAmount"
                headerName="Cheque Amount"
                width={150}
                sortable
                resizable
                filter
                valueFormatter={this.currencyFormatter}
              />
              <AgGridColumn
                width={130}
                headerName="Process"
                cellRendererFramework={this.renderButton}
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  renderButton = params => {
    return (
      <p>
        <a
          onClick={this.onProcessClick}
          className="text-primary"
          data={params.data}
          _id={params.data._id}
        >
          Click Here
        </a>
      </p>
    );
  };

  onProcessClick = e => {
    var res = window.confirm("Are you sure to proceed ?");
    if (res == true) {
      var _id = e.target.getAttribute("_id");

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
            "/account/processCheque/"+
            _id
        )
        .then(res => {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Cheque Processed !!!"
          });
          this.LoadData();
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong !!"
          });
        });
    }
  };

  dateFormatter(params) {

    if (params.value != null) {
      var arr = params.value.split("-");
      if (parseInt(arr[0]) != 1)
        return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
      else
        return "";
    } else {
      return "";
    }
  }

  mainValueChanged = params => {
    this.state[`Main_${params.data._id}`] = params.data.mainRet;
  };

  subValueChanged = params => {
    this.state[`Sub_${params.data._id}`] = params.data.subRet;
  };

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }
}
